import { useContext } from 'react';
import { BaseWidgetContext } from '../WidgetContext.js';
const useBaseWidget = () => {
    return useContext(BaseWidgetContext);
};
export default useBaseWidget;
